import { LoanStatusType } from '../../../../../../../../../common/constants/LoanStatusType';
import { SetupLoanContext } from '../constants/setupForm';

/** The FDILA agreement fields only apply to Outstanding/Repaid loans. */
export const showsFdilaAgreement = (context: SetupLoanContext) =>
    context.statusId === LoanStatusType.Outstanding || context.statusId === LoanStatusType.Repaid;
